export default {
  common: {
    save: "Salvar alterações",
    cancel: "Cancelar",
    saving: "Salvando...",
    updating: "Atualizando...",
    back: "Voltar",
    error: "Erro",
    success: "Sucesso",
    toast: {
      success: "Sucesso",
      error: "Erro",
      info: "Informação",
      warning: "Aviso",
      copied: "Copiado para a área de transferência",
      saved: "Alterações salvas",
      deleted: "Excluído com sucesso",
      updated: "Atualizado com sucesso"
    },
    in: "em"
  },
  auth: {
    signOut: "Sair",
    signOutSuccess: "Saída realizada com sucesso",
    redirectingHome: "Redirecionando para a página inicial...",
    loginWithEmail: "Login com e-mail",
    createAccount: "Criar conta",
    welcomeBack: "Bem-vindo de volta",
    enterEmailForCode: "Digite seu e-mail para receber um código de uso único",
    signUpToManageTrips: "Cadastre-se para começar a gerenciar suas viagens",
    signInToAccessTrips: "Entre para acessar suas viagens",
    password: "Senha",
    otpLogin: "Login e-mail",
    register: "Registrar",
    emailConfirmationRequired: "Confirmação de e-mail necessária",
    checkEmailForConfirmation: "Por favor, verifique sua caixa de entrada para um link de confirmação. Você precisa confirmar seu endereço de e-mail antes de continuar.",
    passwordValidation: "A senha deve conter pelo menos uma letra maiúscula, uma letra minúscula, um número, um caractere especial e deve ter entre 8 e 15 caracteres.",
    invalidEmail: "Por favor, digite um endereço de e-mail válido",
    confirmEmail: "Confirmar endereço de e-mail",
    emailMismatch: "Os endereços de e-mail não correspondem",
    verificationEmailSent: "Por favor, verifique seus e-mails para encontrar um código de verificação.",
    incorrectVerificationCode: "O código de verificação está incorreto",
    loginSuccess: "Login realizado com sucesso!",
    registrationPasswordSuccess: "Registro realizado com sucesso e senha salva!",
    incorrectCredentials: "Credenciais incorretas",
    otpRequestFailed: "Falha na solicitação do OTP",
    unexpectedError: "Ocorreu um erro inesperado",
    codeSent: "Código enviado",
    checkEmailForCode: "Por favor, verifique seu e-mail para o código de verificação.",
    sessionCreationFailed: "Falha ao criar sessão",
    enterVerificationCode: "Digite o código de verificação enviado para",
    enter6DigitCode: "Digite o código de 6 dígitos",
    optionalPassword: "Você pode opcionalmente definir uma senha para sua conta",
    passwordOptional: "Senha (Opcional)",
    confirmPassword: "Confirmar senha",
    registrationComplete: "Registro completo!",
    accountCreatedRedirect: "Sua conta foi criada com sucesso. Você será redirecionado em breve...",
    validateEmail: "Validar seu e-mail",
    signIn: "Entrar",
    sending: "Enviando...",
    verifyEmail: "Verificar e-mail",
    backToEmail: "Voltar ao e-mail",
    verifying: "Verificando...",
    validateOTP: "Validar OTP",
    noAccount: "Não tem uma conta? Cadastre-se",
    travelAppLogo: "Aplicativo de viagem",
    forgotPasswordInstructions: "Por favor, faça login usando seu e-mail e depois altere sua senha",
    forgotPassword: "Esqueceu a senha",
    firstName: "Nome",
    lastName: "Sobrenome",
    emailAddress: "Endereço de e-mail",
    confirmEmailAddress: "Confirmar endereço de e-mail",
    termsAgreementPart1: "Ao criar sua conta, você concorda com nossos",
    termsOfService: "Termos de Serviço",
    privacyPolicy: "Política de Privacidade",
    adtdTripPWaiting: "Sua viagem está pronta para ser importada",
    adtdTripPWaitingDescription: "Por favor, faça login em sua conta ou crie uma para prosseguir. Garantiremos que a reserva corresponda à sua identidade.",
    loginDescription: "Acompanhe voos, organize suas viagens e acesse todas as suas informações de viagem. Tudo o que você precisa para uma jornada tranquila, em um só lugar.",
    loginAppDescription: "Todas as suas informações de viagem em um só lugar"
  },
  settings: {
    title: "Configurações",
    profile: {
      title: "Meu perfil",
      firstName: "Nome",
      lastName: "Sobrenome",
      email: "Endereço de e-mail",
      country: "País",
      city: "Cidade",
      selectCountry: "Selecione ou digite um país",
      enterCity: "Digite sua cidade"
    },
    language: {
      title: "Idioma",
      preferred: "Idioma preferido",
    },
    currency: {
      title: "Moeda",
      preferred: "Moeda preferida"
    },
    notifications: {
      title: "Notificações",
      emailNotifications: "Notificações por e-mail",
      description: "Receber notificações por e-mail sobre atualizações importantes",
    },
    consent: {
      title: "Gerenciador de consentimento",
      open: "Abrir gerenciador de consentimento",
      description: "Gerencie suas preferências de privacidade e cookies"
    },
    about: {
      title: "Sobre nós",
      tos: "Termos de serviço",
      privacy: "Política de privacidade",
      faq: "FAQ",
    },
    contact: {
      title: "Fale conosco",
      email: "feedback@checkmytrip.com",
    },
    social: {
      title: "Siga-nos nas redes sociais",
    },
    profileUpdated: "Perfil atualizado com sucesso",
    updateError: "Erro ao atualizar o perfil",
    passwordMismatch: "As senhas não coincidem",
    passwordTooShort: "A senha deve ter pelo menos 8 caracteres",
    passwordUpdated: "Senha atualizada com sucesso",
    changePassword: "Alterar Senha",
    newPassword: "Nova Senha",
    confirmPassword: "Confirmar Senha",
    updatePassword: "Atualizar Senha",
    deleteAccount: "Excluir conta",
    deleteAccountDescription: "Excluir permanentemente sua conta e todos os dados associados",
    confirmDelete: "Tem certeza?",
    deleteWarning: "Esta ação não pode ser desfeita. Isso excluirá permanentemente sua conta e removerá todos os seus dados de nossos servidores.",
    confirmDeleteButton: "Sim, excluir minha conta",
    accountDeleted: "Sua conta foi excluída com sucesso.",
    deleteError: "Falha ao excluir conta",
    feedback: {
      title: "Comentários",
      description: "Valorizamos seus comentários. Ajude-nos a melhorar nosso serviço compartilhando suas opiniões.",
      button: "Dar feedback"
    }
  },
  index: {
    greeting: "Olá, Viajante",
    greetingWithName: "Olá, {{name}}",
    manageTrips: "Gerencie suas viagens",
    bookingRef: "Referência da reserva",
    lastName: "Sobrenome",
    addTrip: "Adicionar viagem",
    timeline: "Sua linha do tempo",
    travelPlans: "Seus Planos de Viagem",
    welcome: {
      title: "Bem-vindo à Sua Jornada de Viagem!",
      features: {
        tripManagement: {
          title: "Gestão de Viagens",
          description: "Mantenha todos os detalhes da sua viagem em um só lugar - voos, hotéis e atividades."
        },
        tripAlerts: {
          title: "Alertas de Viagem",
          description: "Receba notificações oportunas sobre seus voos, mudanças de portão e atualizações importantes."
        },
        offers: {
          title: "Ofertas Personalizadas",
          description: "Receba ofertas de viagem personalizadas com base em suas preferências e viagens anteriores."
        },
        inspiration: {
          title: "Inspiração de Viagem",
          description: "Descubra novos destinos e receba recomendações personalizadas para suas aventuras"
        }
      },
      tips: {
        profile: "Complete seu perfil para obter recomendações personalizadas",
        addTrip: "Clique no botão + para começar a planejar sua primeira viagem",
        notifications: "Ative as notificações para não perder atualizações importantes",
        dates: "Acompanhe datas importantes de viagem no seu calendário"
      },
      getStarted: "Dicas Rápidas para Começar",
      ready: "Pronto para começar sua jornada? Vamos tornar cada viagem memorável! ✈️"
    },
    importAdtdTripSuccess: "Viagem importada com sucesso",
    importAdtdTripError: "Não foi possível importar a viagem para esta conta",
    checkYourTrips: "Verifique suas viagens no aplicativo",
    errorFetchingTrips: "Certifique-se de estar conectado a uma conta com nome e e-mail correspondentes."
  },
  tripCard: {
    daysLeft: "dias",
    flightDetails: "Detalhes do voo",
    terminal: "Terminal",
    gate: "Portão",
    checkIn: "Check-in",
    flightInfo: "Informações do voo",
    airline: "Companhia aérea",
    flight: "Voo",
    departure: "Partida",
    arrival: "Chegada",
    getFlightDetails: "Detalhes do voo",
    destinationInfo: "Info do destino",
    weather: "Clima",
    activities: "Atividades recomendadas",
    food: "Restaurantes e cafés",
    checkStatus: "Verificar status",
    tripStatus: {
      ongoing: "Viagem em andamento",
      upcoming: "Viagem futura",
      past: "Viagem passada"
    },
    hotel: "Hotel",
    car: "Carro",
    activity: "Atividade",
    viewOnMap: "Ver no mapa",
    direct: "Direto",
    addToCalendar: "Adicionar ao calendário",
    today: "Hoje",
    dayAgo: "1 dia atrás",
    daysAgo: "{{count}} dias atrás",
    remainingDay: "1 dia restante",
    remainingDays: "{{count}} dias restantes",
    tripDetails: "Detalhes da viagem",
    deleteTrip: "Excluir viagem",
    confirmDelete: "Excluir viagem?",
    deleteWarning: "Esta ação não pode ser desfeita. Isso excluirá permanentemente sua viagem para {{tripName}} e a removerá da sua conta.",
    confirmDeleteButton: "Sim, excluir viagem",
    tripDeleted: "A viagem foi excluída com sucesso.",
    deleteError: "Falha ao excluir viagem",
    carRental: "Aluguel de Carro",
    carModel: "Modelo do Carro",
    pickupLocation: "Local de Retirada",
    dropoffLocation: "Local de Devolução",
    pickup: "Retirada",
    dropoff: "Devolução",
    confirmationNumber: "Número de Confirmação",
    notifications: "Notificações",
    notificationsDescription: "Notificações importantes sobre suas viagens",
    noNotifications: "Nenhuma notificação ainda",
    notificationsOnMobile: "Este recurso está disponível apenas no aplicativo móvel no momento.",
    taxiTransfer: "Transfer de Táxi",
    taxiTransferDesc: "Reserve um transfer de táxi para seu hotel ou aeroporto",
    taxiTransferComingSoon: "Transfer de táxi em breve",
    economy: "Econômica",
    loadingNotifications: "Carregando notificações..."
  },
  newTrip: {
    title: "Adicionar nova viagem",
    bookingReference: "Referência da reserva",
    bookingReferenceDesc: "Digite sua referência de reserva de 6 caracteres e certifique-se de que o nome e sobrenome do seu perfil são os mesmos utilizados na sua reserva.",
    bookingRefPlaceholder: "Referência (ex: ABC123)",
    bookingRefTooShort: "A referência da reserva deve ter pelo menos 6 caracteres",
    bookingRefTooLong: "A referência da reserva pode ter no máximo 10 caracteres",
    lastNamePlaceholder: "Sobrenome",
    findBooking: "Encontrar reserva",
    gmailSync: "Sincronizar com Gmail",
    gmailSyncDesc: "Permita-nos verificar sua caixa de entrada do Gmail em busca de reservas de viagem",
    connectGmail: "Conectar conta Gmail",
    emailForward: "Encaminhar email de reserva",
    emailForwardDesc: "Encaminhe seu email de confirmação de reserva para adicionar sua viagem",
    emailCopied: "Endereço de email copiado",
    emailCopiedDesc: "O endereço de email foi copiado para a área de transferência",
    copyEmail: "Copiar endereço de email",
    manual: "Entrada manual",
    manualDesc: "Adicione os detalhes da sua viagem manualmente",
    startManual: "Iniciar entrada manual",
    bookingSubmitted: "Reserva enviada",
    processingBooking: "Procurando sua reserva...",
    gmailConsent: "Conexão Gmail",
    gmailProcessing: "Conectando à sua conta Gmail...",
    manualEntry: "Entrada manual de viagem",
    manualEntryDesc: "Criar uma viagem adicionando detalhes de voos e hotéis você mesmo",
    drawer: {
      addTripDetails: "Adicionar detalhes da viagem",
      tripInfo: "Informações da viagem",
      tripName: "Nome da viagem",
      tripType: "Tipo de viagem",
      selectTripType: "Selecione o tipo de viagem",
      leisure: "Lazer",
      business: "Negócios",
      family: "Família",
      bleisure: "Lazer e negócios",
      travelers: "Número de viajantes",
      addFlight: "Adicionar voo",
      flightNumber: "Número do voo (ex: JJ1234)",
      departureDate: "Data de partida",
      addedFlights: "Voos adicionados",
      from: "De:",
      to: "Para:",
      terminal: "Terminal:",
      departure: "Partida:",
      arrival: "Chegada:",
      addHotel: "Adicionar hotel",
      hotelName: "Nome do hotel",
      cityName: "Nome da cidade",
      selectCheckInOut: "Selecionar datas de check-in/check-out",
      addedHotels: "Hotéis adicionados",
      createTrip: "Criar viagem",
      adding: "Adicionando...",
      selectFlight: "Selecione voo",
      confirmFlight: "Confirmar voo",
      step1: "Info",
      step2: "Voos",
      step3: "Hotéis",
      step4: "Revisão",
      next: "Próximo",
      back: "Voltar",
      review: "Revisar",
      flightsStepEmpty: "Adicione pelo menos um voo à sua viagem",
      flightsStepWithFlights: "Você adicionou {{count}} voo(s)",
      hotelsStepEmpty: "Adicione hotéis à sua viagem (opcional)",
      hotelsStepWithHotels: "Você adicionou {{count}} hotel(is)",
      reviewTrip: "Revise sua viagem",
      reviewDescription: "Verifique os detalhes da sua viagem antes de criá-la",
      tripSummary: "Resumo da viagem",
      flightsSummary: "Voos",
      hotelsSummary: "Hotéis"
    },
    profileMismatch: "Desculpe, as informações do seu perfil não correspondem à reserva. Por favor, acesse o seu Perfil e certifique-se de que seu nome e sobrenome são os mesmos que foram usados para fazer a reserva. Você também pode tentar importar sua viagem com as opções a seguir, encaminhando seu e-mail de confirmação de reserva ou inserindo a viagem manualmente."
  },
  discover: {
    title: "Descubra Experiências",
    subtitle: "Encontre e explore atividades para sua próxima aventura",
    getInspired: "Inspire-se",
    searchFilters: "Filtros de Busca",
    search: "Busca",
    city: "Cidade",
    enterCityName: "Digite o nome da cidade",
    priceRange: "Faixa de Preço",
    min: "Mín",
    max: "Máx",
    radius: "Raio (km)",
    enterRadius: "Digite o raio",
    searchButton: "Buscar",
    categoryTypes: "Categorias",
    popularActivities: "Atividades Populares",
    searchPlaceholder: "Buscar atividades, lugares ou experiências...",
    allActivities: "Todas as Atividades",
    inspiration: {
      location: "Localização",
      price: "Faixa de Preço",
      bestTimeToVisit: "Melhor Época para Visitar",
      howToGetThere: "Como Chegar"
    },
    categories: {
      tour: "Tour",
      adventure: "Aventura",
      food: "Comida e Bebida",
      culture: "Cultura",
      sightseeing: "Passeios Turísticos",
      entertainment: "Entretenimento",
      nature: "Natureza",
      wellness: "Bem-estar",
      sport: "Esporte",
      workshop: "Oficina"
    }
  },
  weather: {
    in: "Clima em",
    loading: "Carregando dados do clima...",
    currentWeather: "Clima atual",
    forecast: "Previsão",
    temperature: "Temperatura",
    feelsLike: "Sensação térmica",
    wind: "Vento",
    humidity: "Umidade",
    precipitation: "Precipitação",
    pressure: "Pressão",
    visibility: "Visibilidade",
    uvIndex: "Índice UV",
    sunrise: "Nascer do sol",
    sunset: "Pôr do sol",
    daily: "Diário",
    hourly: "Por hora",
    today: "Hoje",
    tomorrow: "Amanhã",
    min: "Mín",
    max: "Máx"
  },
  sidebar: {
    myTrips: "Minhas Viagens",
    discover: "Descobrir",
    newTrip: "Nova Viagem",
    profile: "Perfil",
    feedback: "Comentários"
  },
  cabinClass: "Classe da cabine",
  bookingReference: "Referência de reserva",
  confirmationNumbers: "Números de confirmação"
}
